// extracted by mini-css-extract-plugin
export default {"pcBox":"index_pcBox_rmtJU","pcBody":"index_pcBody_CdWLK","pcBoxImg":"index_pcBoxImg_tvez-","pcBottom":"index_pcBottom_YDbh3","pcBottomP":"index_pcBottomP_DXQvH"};